module.exports = __webpack_public_path__ + "static/img/twjd-sdo15.79733c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo15.png
// module id = 857
// module chunks = 0